import {FragmentData, ReviewSectionData} from "src/app/model/ReviewData";
import {GetReviewResponseData} from "src/app/api/model/response/GetReviewResponse";
import {ReOpenFor, ReviewResult, ReviewStatus, ReviewType, ValueType} from "src/app/constant/Enums";

// mock case result fragment
const MOCK_CASE_RESULT_MAIN_FRAGMENT: FragmentData = {
    visible: true,
    rows: [
        {
            context: "BWND Threshold Met: %val",
            elements: [
                {
                    elementType: "PLAIN_TEXT",
                    element: {
                        jsonVal: "A",
                        type: "SINGLE_ITEM"
                    }
                }
            ]
        },
        {
            context: "Lookback Period: %val",
            elements: [
                {
                    element: {
                        jsonVal: "30 days",
                        type: "SINGLE_ITEM"
                    },
                    elementType: "PLAIN_TEXT"
                }
            ]
        },
        {
            context: "AMZL BWNDS: %val ",
            elements: [
                {
                    element: {
                        jsonVal: "10",
                        type: "SINGLE_ITEM"
                    },
                    elementType: "PLAIN_TEXT"
                }
            ]
        },
        {
            context: "SSD BWNDS: %val",
            elements: [
                {
                    element: {
                        jsonVal: "10",
                        type: "SINGLE_ITEM"
                    },
                    elementType: "PLAIN_TEXT"
                }
            ]
        },
        {
            context: "GSF BWNDS: %val",
            elements: [
                {
                    element: {
                        jsonVal: "10",
                        type: "SINGLE_ITEM"
                    },
                    elementType: "PLAIN_TEXT"
                }
            ]
        },
        {
            context: "ROAR BWNDS: %val",
            elements: [
                {
                    element: {
                        jsonVal: "10",
                        type: "SINGLE_ITEM"
                    },
                    elementType: "PLAIN_TEXT"
                }
            ]
        },
        {
            context: "RSR BWNDS: %val",
            elements: [
                {
                    element: {
                        jsonVal: "10",
                        type: "SINGLE_ITEM"
                    },
                    elementType: "PLAIN_TEXT"
                }
            ]
        },
        {
            context: "BWNDs in %val lookback: %val",
            elements: [
                {
                    element: {
                        jsonVal: "30 days",
                        type: "SINGLE_ITEM"
                    },
                    elementType: "PLAIN_TEXT"
                },
                {
                    element: {
                        jsonVal: "50",
                        type: "SINGLE_ITEM"
                    },
                    elementType: "PLAIN_TEXT"
                }
            ]
        },
        {
            context: "Blocks in %val lookback: (%val)",
            elements: [
                {
                    element: {
                        jsonVal: "30 days",
                        type: "SINGLE_ITEM"
                    },
                    elementType: "PLAIN_TEXT"
                },
                {
                    element: {
                        jsonVal: "50",
                        type: "SINGLE_ITEM"
                    },
                    elementType: "PLAIN_TEXT"
                }
            ]
        },
        {
            context: "BWND Rate in %val lookback: %val",
            elements: [
                {
                    element: {
                        jsonVal: "30 days",
                        type: "SINGLE_ITEM"
                    },
                    elementType: "PLAIN_TEXT"
                },
                {
                    element: {
                        jsonVal: "100%",
                        type: "SINGLE_ITEM"
                    },
                    elementType: "PLAIN_TEXT"
                }
            ]
        },
        {
            context: "BWND Probability Score: %val",
            elements: [
                {
                    element: {
                        jsonVal: "0.0125",
                        type: "SINGLE_ITEM"
                    },
                    elementType: "PLAIN_TEXT"
                }
            ]
        },
        {
            context: "AE DP Blurb Sent: %val",
            elements: [
                {
                    elementType: "HREF",
                    element: {
                        jsonVal: "{\"name\":\"blur_link\",\"href\":\"https://quip-amazon.com/MqWvAXIm9LOP/Eagle-Eye-Portal-LLD\"}",
                        type: "MAP"
                    }
                }
            ]
        },
        {
            context: "%val",
            elements: [
                {
                    elementType: "PLAIN_TEXT",
                    element: {
                        jsonVal: "[\"CASE_DETAIL_1\",\"CASE_DATA_POINT_1\"]",
                        type: "LIST"
                    }
                }
            ]
        }
    ]
}

const MOCK_CASE_RESULT_FRAGMENTS = new Map<string, FragmentData>();

MOCK_CASE_RESULT_FRAGMENTS.set("main", MOCK_CASE_RESULT_MAIN_FRAGMENT);

const MOCK_CASE_RESULT_REVIEW_SECTION_DATA: ReviewSectionData = {
    fragments: MOCK_CASE_RESULT_FRAGMENTS,
    title: "Case Data Point"
}

// mock image review fragment
const MOCK_REVIEW_SECTION_IMAGE_FRAGMENT: FragmentData = {
    visible: true,
    rows: [
        {
            context: "%val",
            elements: [
                {
                    elementType: "IMAGE",
                    element: {
                        jsonVal: "https://miro.medium.com/v2/resize:fit:1200/1*20t6cUfMUcxWn8GFb94sPg.png",
                        type: "SINGLE_ITEM"
                    }
                }
            ]
        }
    ]
}

const MOCK_IMAGE_REVIEW_FRAGMENTS = new Map<string, FragmentData>();

MOCK_IMAGE_REVIEW_FRAGMENTS.set("main", MOCK_REVIEW_SECTION_IMAGE_FRAGMENT);

const MOCK_IMAGE_REVIEW_SECTION_DATA: ReviewSectionData = {
    fragments: MOCK_IMAGE_REVIEW_FRAGMENTS,
    title: "DL Review"
}

// mock user input fragment
const MOCK_REVIEW_SECTION_USER_INPUT_FRAGMENT: FragmentData = {
    visible: true,
    rows: [
        {
            context: "Was the device used by DP mapped to at least 5 other DP ids? %val",
            elements: [
                {
                    elementType: "RADIO_BUTTON_GROUP",
                    element: {
                        jsonVal: "{\"options\":[\"No\",\"Yes\",\"N/A\"],\"selected\":null,\"key\":\"auditorInput-answer-1\"}",
                        type: "MAP"
                    }
                }
            ]
        },
        {
            context: "Was the BWND rate of the DP matching our threshold criteria (>0.3)? %val",
            elements: [
                {
                    elementType: "RADIO_BUTTON_GROUP",
                    element: {
                        jsonVal: "{\"options\":[\"No\",\"Yes\",\"N/A\"],\"selected\":null,\"key\":\"auditorInput-answer-2\"}",
                        type: "MAP"
                    }
                }
            ]
        },
        {
            context: "Was the Defect rate of the DP matching our threshold criteria (>0.2)? %val",
            elements: [
                {
                    elementType: "RADIO_BUTTON_GROUP",
                    element: {
                        jsonVal: "{\"options\":[\"No\",\"Yes\",\"N/A\"],\"selected\":null,\"key\":\"auditorInput-answer-3\"}",
                        type: "MAP"
                    }
                }
            ]
        },
        {
            context: "Was there any selfie taken by the DP in the last 30 days ? %val",
            elements: [
                {
                    elementType: "RADIO_BUTTON_GROUP",
                    element: {
                        jsonVal: "{\"options\":[\"No\",\"Yes\",\"N/A\"],\"selected\":null,\"key\":\"auditorInput-answer-4\"}",
                        type: "MAP"
                    }
                }
            ]
        },    
    ]
}

const MOCK_USER_INPUT_REVIEW_FRAGMENTS = new Map<string, FragmentData>();

MOCK_USER_INPUT_REVIEW_FRAGMENTS.set("main", MOCK_REVIEW_SECTION_USER_INPUT_FRAGMENT);

const MOCK_USER_INPUT_REVIEW_SECTION_DATA: ReviewSectionData = {
    fragments: MOCK_USER_INPUT_REVIEW_FRAGMENTS,
    title: "Audit Checks"
}

const MOCK_LAST_REVIEW_DECISION_DETAIL = {
    reasonCode: {
        jsonVal: "Approval",
        type: ValueType.SINGLE_ITEM,
    },
    comment: {
        jsonVal: "comment",
        type: ValueType.SINGLE_ITEM,
    }
}

export const MOCK_REVIEW_DATA: GetReviewResponseData = {
    caseType: "BWND",
    caseSubType: "BWND",
    businessType: "DEFAULT",
    lastReviewDecisionDetail: MOCK_LAST_REVIEW_DECISION_DETAIL,
    country: "US",
    creationDate: "2024-05-17T15:11:07.057569896Z",
    lastModifiedBy: "ewm",
    lastModifiedDate: "2024-05-17T15:11:07.057630113Z",
    referenceId: "A1GQ9DN6E5FYYO",
    referenceSubType: "DP",
    referenceType: "Transporter",
    reviewId: "0afa6528-95ca-4ba0-9fd4-c56132b8e3eb",
    reviewStatus: ReviewStatus.PENDING,
    reviewResult: ReviewResult.NO_ACTION,
    uiLayoutId: "DEFAULT_UI_LAYOUT",
    reviewType: ReviewType.PRIMARY_AUDIT,
    reOpenFor: 'RECTIFYING',
    reviewSections: [MOCK_CASE_RESULT_REVIEW_SECTION_DATA, MOCK_USER_INPUT_REVIEW_SECTION_DATA,
        MOCK_CASE_RESULT_REVIEW_SECTION_DATA, MOCK_IMAGE_REVIEW_SECTION_DATA]
}
